<template>
  <footer class="footer">
    <div class="footer__container">
      <CheckoutFooterMain v-if="isCheckoutPage" />
      <FooterMain v-else />
      <FooterDevelopers :messages="messages" />
    </div>
    <AcceptCookies />
    <DefGoToTop />
    <FooterMiniBanner v-if="footerMiniBanner.doShowMiniBanner" :result="footerMiniBanner" />
  </footer>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FooterMain from '@components/Footer/FooterMain.vue';
import FooterDevelopers from '@components/Footer/FooterDevelopers.vue';
import AcceptCookies from '@components/Modals/AcceptCookies/AcceptCookies.vue';
import DefGoToTop from '@components/Def/DefGoToTop/DefGoToTop.vue';
import FooterMiniBanner from '@components/Footer/FooterMiniBanner.vue';
import useModal from '@use/useModal/useModal';
import ChangeSiteVersion from '@components/Modals/ChangeSiteVersion/ChangeSiteVersion.vue';
import Helpers from '@/libs/Helpers';
import CheckoutFooterMain from '@components/Checkout/CheckoutFooter/CheckoutFooterMain.vue';

const helpers = new Helpers();

export default {
  name: 'Footer',
  components: {
    CheckoutFooterMain,
    FooterMiniBanner,
    DefGoToTop,
    AcceptCookies,
    FooterDevelopers,
    FooterMain,
  },
  data() {
    return {
      modal: useModal(),
      changeSiteVersion: helpers.getCookie('WebsiteVersionModalShowed'),
    };
  },
  computed: {
    ...mapState({
      messages: ({ results }) => results?.messages,
      footerMiniBanner: ({ footerMiniBanner }) => footerMiniBanner?.data,
      subscribe: ({ results }) => results?.subscribe,
    }),
    isCheckoutPage() {
      return this.$route.path.includes('/personal/order/make/');
    },
  },
  methods: {
    ...mapActions({
      getBackBasketItems: 'basket/getBackBasketItems',
      refreshMiniBanner: 'footerMiniBanner/refreshMiniBanner',
    }),
    removeIPostDataFromStorage() {
      this.getBackBasketItems();
    },
    changeSiteVersionModal() {
      if (!this.changeSiteVersion) {
        this.modal.show(ChangeSiteVersion, {}, { width: '440px', backgroundClose: false });
      }
    },
  },
  created() {
    this.removeIPostDataFromStorage();
  },

  mounted() {
    this.refreshMiniBanner(location.pathname);

    this.changeSiteVersionModal();
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: var(--background-black);
  color: #fff;
  &__container {
    @extend %container;
  }
}
</style>
